import {Component, Input, OnInit} from '@angular/core';
import {DataTableComponent} from "../DataTableComponent";
import {DriverService} from "../../services/driver.service";
import {ConfirmationService} from "../../services/confirmation.service";
import {NbToastrService} from "@nebular/theme";
import {ActivatedRoute, Router} from "@angular/router";
import {takeUntil} from "rxjs/operators";
import {ReviewService} from "../../services/review.service";
import {SelectOption} from "../../models/select-option";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'app-review-table',
  templateUrl: './review-table.component.html',
  styleUrls: ['./review-table.component.scss']
})
export class ReviewTableComponent extends DataTableComponent implements OnInit {
    displayedColumns = ['byUser', 'forUser', 'booking', 'rating', 'tags', 'text', 'createdTs', 'actions'];
    @Input() byUser: string = null;
    @Input() forUser: string = null;
    @Input() booking: string = null;
    filterRatings: SelectOption<any>[] = [
        {label: 'Pozitive (4,5)', value: 'positive'},
        {label: 'Negative (1,2,3)', value: 'negative'},
    ];
    filterByUserType: SelectOption<any>[] = [
        {label: 'Sofer', value: 'driver'},
        {label: 'Client', value: 'rider'},
    ];

    constructor(
        protected reviewService: ReviewService,
        private confirmationService: ConfirmationService,
        public authService: AuthService,
        toastr: NbToastrService,
        router: Router,
        route: ActivatedRoute
    ) {
        super(toastr, router, route, (params) => reviewService.getAllExtra(params, this.byUser, this.forUser, this.booking));
    }

    ngOnInit() {
        super.ngOnInit();

        this.reviewService.dataChanged$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
                this.handleParamsChanged();
            });
    }

    delete(reviewId) {
        this.confirmationService.confirm({
            onSuccess: async () => {
                this.isLoading = true;
                await this.reviewService.deleteOne(reviewId);
                this.isLoading = false;
                await this.toastr.show('Reviewul a fost stearsa', 'Succes', {status: 'success'});
            },
            title: 'Stergere review',
            message: 'Esti sigur ca doresti sa stergi acesta review?'
        });
    }

}
